<template>
  <sl-page title="修改密码">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="120">
      <FormItem label="原密码" prop="passwdOrigin">
        <Input type="password" v-model="form.oldPassword"></Input>
      </FormItem>
      <FormItem label="新密码" prop="passwd">
        <Input type="password" v-model="form.passwd"></Input>
      </FormItem>
      <FormItem label="确认新密码" prop="passwdCheck">
        <Input type="password" v-model="form.passwdCheck"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('form')">确定</Button>
        <Button @click="handleReset('form')" style="margin-left: 8px">重置</Button>
      </FormItem>
    </Form>
  </sl-page>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.passwdCheck !== '') {
          // 对第二个密码框单独验证
          this.$refs.form.validateField('passwdCheck');
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再此输入密码'))
      } else if (value !== this.form.passwd) {
        callback(new Error('两次密码不一致'))
      } else {
        callback();
      }
    }

    return {
      form: {
        passwd: '',
        passwdCheck: '',
        oldPassword: ''
      },
      rules: {
        passwd: [
          { type: 'string', required: true, message: '请输入新密码', trigger: 'blur,change' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        oldPassword: [
          { type: 'string', required: true, message: '请输入原密码', trigger: 'blur,change' },
        ],
        passwdCheck: [
          { type: 'string', required: true, validator: validatePassCheck, trigger: 'blur,change' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],

      }
    }
  },
  computed: {
    ...mapState({
      account: state => state.auth.account,
    })
  },
  methods: {
    save(){
      let params = { password:this.form.passwd , oldPassword: this.form.oldPassword }
      this.$request.passwordUpdate(params).then(resp=>{
        if(resp.code){
          this.$Message.error({content:resp.msg})
        }else{
          this.$Message.success('修改成功，请重新登录')
          this.$store.dispatch('auth/signout').then((res) => {
            this.$router.push({
              name: 'signin'
            })
          })
        }
      })
    },

    handleSubmit(name) {
      let self = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          self.save()
        } else {
          // this.$Message.error('请输入')
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    }
  }
}

</script>